// 轴网
import Mx from "mxdraw";

import rlEntity from "./rlEntity";
import { create2dAnyLine, create3dAnyLine } from "../threeObject/index";
import store from "@/store";
import { addEntityToDrawing } from "@/rlMxModules/operate/commonApi";
import { rlLine, rlText } from "@/rlMxModules/index";
import { rlCircle } from "@/rlMxModules/class/rlCircle";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
// import { visible } from 'ansi-colors';
// import { isS } from 'xmlchars/xml/1.0/ed5';

class rlLineAxis extends rlEntity {
  constructor() {
    super();

    this.points = []; // 顶点列表
    this.m_stJoint = null; // 起点节点
    this.m_edJoint = null; // 终点节点

    this.Name = "空"; //轴线名称
    this.IsMainAxis = 0; //是否是主轴

    this._threeObj = null; //三维图形对象
    // this.defaultColor = new THREE.Color(0xffffff); //默认颜色
    this.Color = "0xffffff"; //构件颜色
    this.lineWidth = 0; //线宽

    this.classTypeName = "rlAxis"; // 轴线

    this.m_gridIds = new Array(); //轴线上的网格集合
    this.m_groupName = "rlLineAxisGroup";
    //this.mcDbAxis = new McDbLine()----
    //轴线命名数据
    this.m_stText = null;
    this.m_edText = null;
    this.m_stLineTmp = null;
    this.m_edLineTmp = null;
    this.m_stCircle = null;
    this.m_edCircle = null;

    this.lineObjId = -1;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;
    // this.ID = obj.ID;
    this.Name = obj.Name;
    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_stJoint = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_stJoint);
    this.m_edJoint = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_edJoint);
    this.Name = obj.Name;
    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];

    // this.m_stText = rlAppObj.rlMxDrawObject.getMxEntity(m_stText);
    // this.m_edText = rlAppObj.rlMxDrawObject.getMxEntity(m_edText);
    // this.m_stLineTmp = rlAppObj.rlMxDrawObject.getMxEntity(m_stLineTmp);
    // this.m_edLineTmp = rlAppObj.rlMxDrawObject.getMxEntity(m_edLineTmp);
    // this.m_stCircle = rlAppObj.rlMxDrawObject.getMxEntity(m_stCircle);
    // this.m_edCircle = rlAppObj.rlMxDrawObject.getMxEntity(m_edCircle);
  }

  // 添加
  add(obj) {
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;
    // this.ID = obj.ID;
    this.Name = obj.Name;
    this.Guid = obj.Guid ? obj.Guid : this.Guid;
    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];
  }

  // 生成轴线
  setPoints(points) {
    this.points = [
      new THREE.Vector3(...points[0]),
      new THREE.Vector3(...points[1]),
    ];
  }

  // 绘制
  worldDraw(pWorldDraw) {
    if (pWorldDraw.mxObj._is2d) {
      pWorldDraw.setRenderOrder(5);
      // pWorldDraw.setColor(new THREE.Color(this.Color));
      pWorldDraw.setLineWidth(this.lineWidth);
      pWorldDraw.drawLine(this.points[0], this.points[1]);
    }
    this._threeObj = create3dAnyLine(this.points);
    // if (this.m_stJoint) {
    //   if (!this.m_stJoint.m_AxisIds.includes(this.objectId())) {
    //     this.m_stJoint.m_AxisIds.push(this.objectId());
    //   }
    // }
    // if (this.m_edJoint) {
    //   if (!this.m_edJoint.m_AxisIds.includes(this.objectId())) {
    //     this.m_edJoint.m_AxisIds.push(this.objectId());
    //   }
    // }
  }

  //节点变化时轴线相应更新
  updateData(jointObj) {
    if (this.m_gridIds && this.m_gridIds.length > 0) {
      this.saveEditRevokeData(); //修改数据前保存数据

      //删除端点后，若轴线上还存在网格，轴线的端点改变
      //将轴线上的点都提取出来，都点排序，取首尾两点
      let isChangeStart = this.m_stJoint == jointObj ? true : false;

      let axisPt = isChangeStart
        ? new THREE.Vector3(...this.m_edJoint.m_pt)
        : new THREE.Vector3(...this.m_stJoint.m_pt);
      let sortJointData = {};
      this.m_gridIds.forEach((gridId) => {
        let objGrid = rlAppObj.rlMxDrawObject.getMxEntity(gridId);
        let dist1 = new THREE.Vector3(...objGrid.m_stJoint.m_pt).distanceTo(
          axisPt
        );
        let dist2 = new THREE.Vector3(...objGrid.m_edJoint.m_pt).distanceTo(
          axisPt
        );
        if (dist1 > dist2) {
          sortJointData[dist1] = objGrid.m_stJoint;
        } else {
          sortJointData[dist2] = objGrid.m_edJoint;
        }
      });

      if (sortJointData) {
        const lastKey = Object.keys(sortJointData).pop();
        if (isChangeStart) {
          this.m_stJoint = sortJointData[lastKey];
        } else {
          this.m_edJoint = sortJointData[lastKey];
        }
        this.updateThisObj(this);
      }
    } else {
      //否则，删除轴线
      this.erase();
    }
  }

  //数据修改更新
  async updateThisObj(obj, isUpdateDisplay = true) {
    this.initData(obj);
    //删除功能选择多个同时删除时需要及时处理关联关系
    if (this.m_stJoint) {
      if (!this.m_stJoint.m_AxisIds.includes(this.objectId())) {
        this.m_stJoint.m_AxisIds.push(this.objectId());
      }
    }
    if (this.m_edJoint) {
      if (!this.m_edJoint.m_AxisIds.includes(this.objectId())) {
        this.m_edJoint.m_AxisIds.push(this.objectId());
      }
    }
    if (isUpdateDisplay) this.setNeedUpdateDisplay();
    await resetRlModules(
      this.classTypeName,
      store.state.globalData.rl_stdFlr_id,
      this.Guid,
      this.getDataBase()
    );
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    obj["points"] = [];
    this.points.forEach((val) => {
      obj["points"].push(val.clone());
    });
    // if (this.ID) {
    //   this.statusType = 2
    // }
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    //  // 这里是自定义对象自己的属性
    let ary = obj["points"];
    this.points = [];
    ary.forEach((val) => {
      this.points.push(val.clone());
    });
    return true;
  }

  // 删除
  erase() {
    if (this.m_stJoint) {
      if (this.m_stJoint.m_gridIds.includes(this.objectId())) {
        this.m_stJoint.m_gridIds = this.m_stJoint.m_gridIds.filter(
          (item) => item != this.objectId()
        );
        //
      }
    }

    if (this.m_edJoint) {
      if (this.m_edJoint.m_gridIds.includes(this.objectId())) {
        this.m_edJoint.m_gridIds = this.m_edJoint.m_gridIds.filter(
          (item) => item != this.objectId()
        );
        //
      }
    }
    this.m_stText && this.m_stText.erase();
    this.m_edText && this.m_edText.erase();
    this.m_stLineTmp && this.m_stLineTmp.erase();
    this.m_edLineTmp && this.m_edLineTmp.erase();
    this.m_stCircle && this.m_stCircle.erase();
    this.m_edCircle && this.m_edCircle.erase();

    super.erase();
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    if (this.m_stJoint) data["Jt1Guid"] = this.m_stJoint.Guid;

    if (this.m_edJoint) data["Jt2Guid"] = this.m_edJoint.Guid;
    data["Name"] = this.Name;
    data["IsMainAxis"] = this.IsMainAxis;
    return data;
  }

  getDrawData() {
    let data = super.getDrawData();

    data["m_stJoint"] = this.m_stJoint.objectId();
    data["m_edJoint"] = this.m_edJoint.objectId();

    data["Name"] = this.Name;
    data["IsMainAxis"] = this.IsMainAxis;
    data["m_gridIds"] = this.m_gridIds;

    // data["m_stText"] = this.m_stText.objectId();
    // data["m_edText"] = this.m_edText.objectId();
    // data["m_stLineTmp"] = this.m_stLineTmp.objectId();
    // data["m_edLineTmp"] = this.m_edLineTmp.objectId();
    // data["m_stCircle"] = this.m_stCircle.objectId();
    // data["m_edCircle"] = this.m_edCircle.objectId();
    return data;
  }
  // 绘制
  drawLine(s, e) {
    this.points = [s, e];
  }

  // 移动
  transformBy(_mat) {
    // this.points.forEach(item => item.add(_mat))
    // this.setNeedUpdateDisplay(true);
  }

  // 画线(模拟录入)
  drawLineByPoints(straightLineSimulate) {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      fixOrthogonal(false);
      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0 || !straightLineSimulate) {
          return;
        }
        store.commit("drawModules/setDrawPlay", true);
        fixOrthogonal(true);
        // 当前鼠标位置
        const pt1 = getPoint.value();
        if (store.state.platBtns.topBtnActive.id !== 102) return;
        // 实例化任意线段
        this.points.push(pt1);
        const PI_HALF = Math.PI / 2;

        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          // 判断是否中断了绘制
          if (store.state.platBtns.topBtnActive.drawId !== 3) {
            resolve();
            return;
          }
          if (this.points.length === 0) return;
          fixOrthogonal(true);
          this.drawLine(currentPoint, this.points[this.points.length - 1]);
          if (this.points.length >= 2) {
            const startPoint = pt1;
            let endPoint = currentPoint.clone(); // 克隆当前点作为终点
            const distance = startPoint.distanceTo(endPoint);
            const modulusDistance =
              Math.ceil(distance / straightLineSimulate) * straightLineSimulate; // 将距离调整到模数的最近整数倍
            // 保持方向不变，调整endPoint到模数的最近整数倍距离

            endPoint
              .sub(startPoint)
              .normalize()
              .multiplyScalar(modulusDistance)
              .add(startPoint);

            this.drawLine(endPoint, this.points[this.points.length - 1]);
            // 计算两点之间的角度
            let angle = Math.atan2(
              endPoint.y - startPoint.y,
              endPoint.x - startPoint.x
            );
            let angleValue = ((angle * 180) / Math.PI + 360) % 360;
            const value =
              modulusDistance.toFixed(2) +
              "mm" +
              "  " +
              (angleValue === 360 ? 0 : angleValue).toFixed(2) +
              "°";

            // 修正角度在左右侧的显示
            if (angle > PI_HALF || angle < -PI_HALF) {
              angle -= Math.PI;
            }
            const textSize = modulusDistance / 10;

            const midPoint = new THREE.Vector3().lerpVectors(
              startPoint,
              endPoint,
              0.5
            );
            midPoint.y += textSize;
            pWorldDraw.drawText(value, textSize, angle, midPoint);
            // 重复执行绘制
            pWorldDraw.drawCustomEntity(this);
          }
        });
        getPoint.go((status2) => {
          // 鼠标右键结束绘制
          if (status2 !== 0) return resolve();
          resolve(this);
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }
  // 移动端划线(模拟录入)
  drawMobileLineByPoints(straightLineSimulate) {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      fixOrthogonal(false);
      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0 || !straightLineSimulate) {
          return;
        }
        store.commit("drawModules/setDrawPlay", true);
        getPoint.go(() => {
          fixOrthogonal(true);
          // 当前鼠标位置
          const pt1 = getPoint.value();
          if (store.state.platBtns.topBtnActive.id !== 102) return;
          // 实例化任意线段
          this.points.push(pt1);
          const PI_HALF = Math.PI / 2;

          getPoint.setUserDraw((currentPoint, pWorldDraw) => {
            // 判断是否中断了绘制
            if (store.state.platBtns.topBtnActive.drawId !== 3) {
              resolve();
              return;
            }
            if (this.points.length === 0) return;
            fixOrthogonal(true);
            this.drawLine(currentPoint, this.points[this.points.length - 1]);
            if (this.points.length >= 2) {
              const startPoint = pt1;
              let endPoint = currentPoint.clone(); // 克隆当前点作为终点
              const distance = startPoint.distanceTo(endPoint);
              const modulusDistance =
                Math.ceil(distance / straightLineSimulate) *
                straightLineSimulate; // 将距离调整到模数的最近整数倍
              // 保持方向不变，调整endPoint到模数的最近整数倍距离

              endPoint
                .sub(startPoint)
                .normalize()
                .multiplyScalar(modulusDistance)
                .add(startPoint);

              this.drawLine(endPoint, this.points[this.points.length - 1]);
              // 计算两点之间的角度
              let angle = Math.atan2(
                endPoint.y - startPoint.y,
                endPoint.x - startPoint.x
              );
              let angleValue = ((angle * 180) / Math.PI + 360) % 360;
              const value =
                modulusDistance.toFixed(2) +
                "mm" +
                "  " +
                (angleValue === 360 ? 0 : angleValue).toFixed(2) +
                "°";

              // 修正角度在左右侧的显示
              if (angle > PI_HALF || angle < -PI_HALF) {
                angle -= Math.PI;
              }
              const textSize = modulusDistance / 10;

              const midPoint = new THREE.Vector3().lerpVectors(
                startPoint,
                endPoint,
                0.5
              );
              midPoint.y += textSize;
              pWorldDraw.drawText(value, textSize, angle, midPoint);
              // 重复执行绘制
              pWorldDraw.drawCustomEntity(this);
            }
          });
          getPoint.go((status2) => {
            // 鼠标右键结束绘制
            if (status2 !== 0) return resolve();
            resolve(this);
          });
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }
  // test
  // 画线的函数
  async draw() {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      fixOrthogonal(false);
      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0) {
          return;
        }
        store.commit("drawModules/setDrawPlay", true);
        fixOrthogonal(true);
        // 当前鼠标位置
        const pt1 = getPoint.value();
        if (store.state.platBtns.topBtnActive.id !== 102) return;
        // 实例化任意线段
        this.points.push(pt1);
        const PI_HALF = Math.PI / 2;

        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          // 判断是否中断了绘制
          if (store.state.platBtns.topBtnActive.drawId !== 3) {
            resolve();
            return;
          }
          if (this.points.length === 0) return;
          fixOrthogonal(true);
          this.drawLine(currentPoint, this.points[this.points.length - 1]);
          if (this.points.length >= 2) {
            const startPoint = this.points[0];
            const endPoint = this.points[1];
            const distance = startPoint.distanceTo(endPoint);

            // 计算两点之间的角度
            let angle = Math.atan2(
              startPoint.y - endPoint.y,
              startPoint.x - endPoint.x
            );
            let angleValue = ((angle * 180) / Math.PI + 360) % 360;
            const value =
              distance.toFixed(2) +
              "mm" +
              "  " +
              (angleValue === 360 ? 0 : angleValue).toFixed(2) +
              "°";

            // 修正角度在左右侧的显示
            if (angle > PI_HALF || angle < -PI_HALF) {
              angle -= Math.PI;
            }
            const textSize = distance / 10;

            const midPoint = new THREE.Vector3().lerpVectors(
              startPoint,
              endPoint,
              0.5
            );
            midPoint.y += textSize;
            pWorldDraw.drawText(value, textSize, angle, midPoint);
            // 重复执行绘制
            pWorldDraw.drawCustomEntity(this);
          }
        });
        // 第二次点击鼠标
        getPoint.go((status2) => {
          if (status2 !== 0) return resolve();
          resolve(this);
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }
  // 移动端画直线
  async draw_mobile() {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      fixOrthogonal(false);
      // 移动端第一次点击选点
      getPoint.go((status) => {
        // 移动端第二次点击开始绘制
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0) {
          return;
        }
        store.commit("drawModules/setDrawPlay", true);
        getPoint.go(() => {
          fixOrthogonal(true);
          // 当前鼠标位置
          const pt1 = getPoint.value();
          if (store.state.platBtns.topBtnActive.id !== 102) return;
          // 实例化任意线段
          this.points.push(pt1);
          const PI_HALF = Math.PI / 2;

          getPoint.setUserDraw((currentPoint, pWorldDraw) => {
            // 判断是否中断了绘制
            if (store.state.platBtns.topBtnActive.drawId !== 3) {
              resolve();
              return;
            }
            if (this.points.length === 0) return;
            fixOrthogonal(true);
            this.drawLine(currentPoint, this.points[this.points.length - 1]);
            if (this.points.length >= 2) {
              const startPoint = this.points[0];
              const endPoint = this.points[1];
              const distance = startPoint.distanceTo(endPoint);

              // 计算两点之间的角度
              let angle = Math.atan2(
                startPoint.y - endPoint.y,
                startPoint.x - endPoint.x
              );
              let angleValue = ((angle * 180) / Math.PI + 360) % 360;
              const value =
                distance.toFixed(2) +
                "mm" +
                "  " +
                (angleValue === 360 ? 0 : angleValue).toFixed(2) +
                "°";

              // 修正角度在左右侧的显示
              if (angle > PI_HALF || angle < -PI_HALF) {
                angle -= Math.PI;
              }
              const textSize = distance / 10;

              const midPoint = new THREE.Vector3().lerpVectors(
                startPoint,
                endPoint,
                0.5
              );
              midPoint.y += textSize;
              pWorldDraw.drawText(value, textSize, angle, midPoint);
              // 重复执行绘制
              pWorldDraw.drawCustomEntity(this);
            }
          });
          // 第二次点击鼠标
          getPoint.go((status2) => {
            if (status2 !== 0) return resolve();
            resolve(this);
          });
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }

  //计算轴线命名数据
  calAxisNameData(isVisible = false) {
    //判断是否已经加载过轴线命名数据
    if (!store.state.globalData.rlAxisLineLoad.includes(this.Guid)) {
      store.commit("globalData/addGuidToRlAxisLineLoad", this.Guid);

      //轴线命名的显示隐藏
      this.visible = isVisible;
      //计算直线的方向
      let stPos = new THREE.Vector3(
        this.points[0].x,
        this.points[0].y,
        this.points[0].z
      );
      let edPos = new THREE.Vector3(
        this.points[1].x,
        this.points[1].y,
        this.points[1].z
      );
      const lineOrigin = new THREE.Line3(stPos, edPos);
      let vecDir = new THREE.Vector3();
      lineOrigin.delta(vecDir);
      vecDir.normalize();

      //绘制轴线命名辅助直线
      let stExternLinePos = new THREE.Vector3(
        stPos.x - vecDir.x * 1500,
        stPos.y - vecDir.y * 1500,
        stPos.z
      );
      this.m_stLineTmp = new rlLine();
      this.m_stLineTmp.setPoints([
        [stPos.x, stPos.y, stPos.z],
        [stExternLinePos.x, stExternLinePos.y, stExternLinePos.z],
      ]);
      this.m_stLineTmp.color = "#0051FF";
      this.m_stLineTmp.visible = isVisible;
      addEntityToDrawing(this.m_stLineTmp);

      //绘制轴线命名辅助直线
      let edExternLinePos = new THREE.Vector3(
        edPos.x + vecDir.x * 1500,
        edPos.y + vecDir.y * 1500,
        edPos.z
      );
      this.m_edLineTmp = new rlLine();
      this.m_edLineTmp.setPoints([
        [edPos.x, edPos.y, edPos.z],
        [edExternLinePos.x, edExternLinePos.y, edExternLinePos.z],
      ]);
      this.m_edLineTmp.color = "#0051FF";
      this.m_edLineTmp.visible = isVisible;
      addEntityToDrawing(this.m_edLineTmp);

      //绘制两端包围文字的圆
      let stExternPos = new THREE.Vector3(
        stPos.x - vecDir.x * 2000,
        stPos.y - vecDir.y * 2000,
        stPos.z
      );
      this.m_stCircle = new rlCircle();
      this.m_stCircle.visible = isVisible;
      this.m_stCircle.setPoints([stExternPos.x, stExternPos.y, stExternPos.z]);
      addEntityToDrawing(this.m_stCircle);

      let edExternPos = new THREE.Vector3(
        edPos.x + vecDir.x * 2000,
        edPos.y + vecDir.y * 2000,
        edPos.z
      );
      this.m_edCircle = new rlCircle();
      this.m_edCircle.visible = isVisible;
      this.m_edCircle.setPoints([edExternPos.x, edExternPos.y, edExternPos.z]);
      addEntityToDrawing(this.m_edCircle);

      //绘制两端轴线名称
      this.m_stText = new rlText();
      this.m_stText.position = stExternPos;
      this.m_stText.Text = this.Name;
      this.m_stText.visible = isVisible;
      this.m_stText.lineObjId = this.objectId();
      // this.stText = this.m_stText.Guid;

      addEntityToDrawing(this.m_stText);

      this.m_edText = new rlText();
      this.m_edText.position = edExternPos;
      this.m_edText.Text = this.Name;
      this.m_edText.visible = isVisible;
      this.m_edText.lineObjId = this.objectId();
      addEntityToDrawing(this.m_edText);
      rlAppObj.rlMxDrawObject.updateDisplay();
    } else {
      this.showAxisName(isVisible);
    }
  }

  updateAxisName(Text) {
    this.Name = Text;
    this.m_stText.Text = String(this.Name ? this.Name : "");
    this.m_stText.setNeedUpdateDisplay(true);

    this.m_edText.Text = String(this.Name ? this.Name : "");
    this.m_edText.setNeedUpdateDisplay(true);
  }

  //轴线命名的显示隐藏
  showAxisName(isShow) {
    this.visible = isShow;
    if (this.m_stText) {
      this.m_stText.visible = isShow;
      this.m_stText.setNeedUpdateDisplay(true);
    }

    if (this.m_edText) {
      this.m_edText.visible = isShow;
      this.m_edText.setNeedUpdateDisplay(true);
    }

    if (this.m_stLineTmp) {
      this.m_stLineTmp.visible = isShow;
      this.m_stLineTmp.setNeedUpdateDisplay(true);
    }

    if (this.m_edLineTmp) {
      this.m_edLineTmp.visible = isShow;
      this.m_edLineTmp.setNeedUpdateDisplay(true);
    }

    if (this.m_stCircle) {
      this.m_stCircle.visible = isShow;
      this.m_stCircle.setNeedUpdateDisplay(true);
    }

    if (this.m_edCircle) {
      this.m_edCircle.visible = isShow;
      this.m_edCircle.setNeedUpdateDisplay(true);
    }
    rlAppObj.rlMxDrawObject.updateDisplay();
  }
}

export { rlLineAxis };
